/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable functional/no-conditional-statement */
import { FC, useEffect } from "react";
import chain from "../../common/images/chain.png";
import { useIsPhrasesAPIErrorValue } from "../../common/miscellaneous/useIsPhrasesAPIErrorValue";
import { useNavigate } from "../../common/hooks/useNavigate";
import { TryAgainButton } from "./TryAgainButton";
import { useTitle } from "../hooks/useTitle";

export const TryAgain: FC = () => {
  useTitle();

  const navigate = useNavigate();
  const isPhrasesError = useIsPhrasesAPIErrorValue();
  useEffect(() => {
    if (!isPhrasesError) {
      // Back to the previous page
      navigate(-1);
    }
  }, [isPhrasesError]);

  return isPhrasesError ? (
    <div className="tw-p-8">
      <div className="tw-flex  tw-justify-center tw-items-center tw-gap-6">
        <img
          src={chain}
          alt="not found"
          className="tw-pr-6 tw-border-r tw-border-gray-200"
        />
        <div className="tw-font-bold">
          <div className="tw-text-2xl">Something went wrong</div>
          <div className="tw-my-3">Refresh the page</div>
          <TryAgainButton />
        </div>
      </div>
    </div>
  ) : null;
};
